import { createActions } from 'redux-actions';

export const {
  uploadCustomerPhoto,
  uploadCustomerPhotoSuccess,
  uploadCustomerPhotoError,
  editCustomer,
  editCustomerSuccess,
  editCustomerError,
  getCustomer,
  getCustomerSuccess,
  getCustomerError,
  searchCustomers,
  searchCustomersSuccess,
  searchCustomersError,
  getFilterCustomers,
  getFilterCustomersSuccess,
  getFilterCustomersError,
  getAllCustomers,
  getAllCustomersSuccess,
  getAllCustomersError,
  addCustomer,
  addCustomerSuccess,
  addCustomerError,
  clearAddCustomerErrors,
} = createActions(
  'UPLOAD_CUSTOMER_PHOTO',
  'UPLOAD_CUSTOMER_PHOTO_SUCCESS',
  'UPLOAD_CUSTOMER_PHOTO_ERROR',
  'EDIT_CUSTOMER',
  'EDIT_CUSTOMER_SUCCESS',
  'EDIT_CUSTOMER_ERROR',
  'GET_CUSTOMER',
  'GET_CUSTOMER_SUCCESS',
  'GET_CUSTOMER_ERROR',
  'SEARCH_CUSTOMERS',
  'SEARCH_CUSTOMERS_SUCCESS',
  'SEARCH_CUSTOMERS_ERROR',
  'GET_FILTER_CUSTOMERS',
  'GET_FILTER_CUSTOMERS_SUCCESS',
  'GET_FILTER_CUSTOMERS_ERROR',
  'GET_ALL_CUSTOMERS',
  'GET_ALL_CUSTOMERS_SUCCESS',
  'GET_ALL_CUSTOMERS_ERROR',
  'ADD_CUSTOMER',
  'ADD_CUSTOMER_SUCCESS',
  'ADD_CUSTOMER_ERROR',
  'CLEAR_ADD_CUSTOMER_ERRORS'
);
